import React from 'react'
import SignUp from './components/SingUp';
import { useDispatch } from 'react-redux'
import cadastroInicial from '../../serviceAPI/cadastroInicial'
import AtivarConta from '../../components/AtivacaoConta'

function Cadastro() {
  const dispatch = useDispatch();

  async function cadastrar(cpfCnpj, firtName, lastName, email, senha) {

    const dados = {
      firstName: firtName,
      lastName: lastName,
      email: email,
      senha: senha,
      cpfcnpj: cpfCnpj
    }

    await cadastroInicial(dados, dispatch);
  }

  return (
    <div>
      <SignUp onSubmit={cadastrar} dispatch={dispatch}/>
      <AtivarConta />
    </div>
  )

}

export default Cadastro;